import {Image, Link} from '@shopify/hydrogen';

import {useFormatDate} from '../../hooks/useFormatDate';

type Props = {
  title: string;
  excerpt: string;
  featuredImage: any;
  date: string;
  slug: {
    current: string;
  };
};

export default function BlogCard({
  featuredImage,
  excerpt,
  title,
  date,
  slug,
}: Props) {
  const dateFormatted = useFormatDate(date);

  return (
    <div>
      {featuredImage?.asset.url && (
        <div className="aspect-w-7 aspect-h-4 relative z-10 w-full overflow-hidden rounded-lg">
          <Link to={`/blog/${slug?.current}`}>
            <Image
              width="inherit"
              height="inherit"
              src={featuredImage?.asset.url}
              alt={title}
              className="transition-standard absolute top-0 left-0 h-full w-full object-cover hover:scale-105"
            />
          </Link>
        </div>
      )}
      <div className="mt-7 flex flex-col gap-y-[10px] text-left">
        <h6 className="richH6">{dateFormatted}</h6>
        <h2 className="richH2 text-orange">{title}</h2>
        <h6 className="richH6">{excerpt}</h6>
        <Link to={`/blog/${slug?.current}`} className="btn-standard">
          Read more
        </Link>
      </div>
    </div>
  );
}
